module.exports = __webpack_public_path__ + "img/card-basic-person.dea304d8.png";